/* global axios */
import ApiClient from './ApiClient';

class ContactNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/notes`;
  }

  get(contactId, params = {}) {
    this.contactId = contactId;
    return axios.get(this.url, { params });
  }

  create(contactId, { content, attachments }) {
    this.contactId = contactId;
    if (attachments && attachments.length) {
      const formData = new FormData();
      formData.append('note[content]', content);
      attachments.forEach(file => {
        formData.append('note[attachments][]', file);
      });
      return super.create(formData);
    }
    return super.create({ content });
  }

  update(contactId, id, { content, attachments, attachmentsToRemove }) {
    this.contactId = contactId;
    if ((attachments && attachments.length) || (attachmentsToRemove && attachmentsToRemove.length)) {
      const formData = new FormData();
      formData.append('note[content]', content);
      if (attachments) {
        attachments.forEach(file => {
          formData.append('note[attachments][]', file);
        });
      }
      if (attachmentsToRemove) {
        attachmentsToRemove.forEach(attachmentId => {
          formData.append('note[attachments_to_remove][]', attachmentId);
        });
      }
      return super.update(id, formData);
    }
    return super.update(id, { content });
  }

  delete(contactId, id) {
    this.contactId = contactId;
    return super.delete(id);
  }
}

export default new ContactNotes();
